/**
 * 操作 显示更多
 */
import React, { Component } from 'react';
import { Dropdown, Menu } from 'antd';
import { getDataType } from '@/shared/functions';
class OpreateShowMore extends Component {
    constructor(props) {
        super(props);
        this._renderMenu = this._renderMenu.bind(this);
    }
    _renderMenu() {
        const { show } = this.props;
        const Children = this.getShowChildren();
        const dropList = ''.padStart(Children.length - show + 1, 'a').split('');
        return Children.length > show ?
            (<Menu className={'drop_operate'}>
          {dropList.map((Item, index) => {
                const time = new Date().getTime() + Math.random();
                return (<Menu.Item key={`drop_${time}`}>
                  {Children[show - 1 + index]}
                </Menu.Item>);
            })}
        </Menu>)
            : null;
    }
    getShowChildren() {
        const { children } = this.props;
        let Children;
        const Frag = <></>;
        if (getDataType(children) !== 'Array') {
            if (children.type === Frag.type) {
                if (getDataType(children.props.children) === 'Array') {
                    Children = [...children.props.children];
                }
                else {
                    Children = [children.props.children];
                }
            }
            else {
                Children = [children];
            }
        }
        else {
            Children = [];
            const effectChildren = children.filter((v) => v);
            effectChildren.forEach((child) => {
                if (child.type === Frag.type) {
                    if (getDataType(child.props.children) === 'Array') {
                        Children.push(...child.props.children);
                    }
                    else {
                        Children.push(child.props.children);
                    }
                }
                else {
                    Children.push(child);
                }
            });
        }
        return Children;
    }
    render() {
        const { show } = this.props;
        const Children = this.getShowChildren();
        const showList = ''.padStart(show - 1, 'a').split('');
        return (<>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
        }}>
          {showList.map((item, index) => {
            return Children[index];
        })}
          {Children.length > show ? (<Dropdown placement="bottomCenter" overlay={this._renderMenu} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
                <a>更多</a>
              </Dropdown>) : (Children[show - 1])}
        </div>
      </>);
    }
}
OpreateShowMore.defaultProps = {
    show: 3,
};
export default OpreateShowMore;
